<template>
    <fieldset :disabled="mode == 'readonly'" style="margin-bottom: 200px">
        <h2>拼团信息</h2>
        <content-block title="关联产品id" isRequired>
            <span>{{relationMtDealId}}</span>
            <Button v-if="this.mode === 'new'" type="primary" :disabled="pulling" :loading="pulling" @click="pull">
                <span v-if="!pulling">拉取产品信息</span>
                <span v-else>拉取中...</span>
            </Button>
        </content-block>
        <content-block title="成团人数" isRequired>
            <InputNumber :disabled="this.mode !== 'new'" :max="1000" :min="2" v-model="model.groupRule.groupNum"></InputNumber>
            &nbsp;&nbsp;&nbsp;&nbsp;<span class="icon-error help-icon"></span> 在"团有效时间"内满足"成团人数"才能拼团成功，取值范围[2, 1000]正整数
        </content-block>
        <content-block title="团有效时间" isRequired>
            <Select :disabled="this.mode !== 'new'" class="inline-input nano-select" v-model="model.groupRule.availableDays">
                <Option v-for="n in 16" :value="n-1" :key="n-1">{{ n-1 }}</Option>
            </Select>
            天
            <Select :disabled="this.mode !== 'new'" class="inline-input nano-select" v-model="model.groupRule.availableHours">
                <Option v-for="n in 23" :value="n" :key="n">{{ n }}</Option>
            </Select>
            小时
            &nbsp;&nbsp;&nbsp;&nbsp;<span class="icon-error help-icon"></span> 1个拼团从发起开始进行倒计时
        </content-block>
    </fieldset>
</template>
<script>
    import ContentBlock from 'components/content-block/index.vue';
    import { categories } from 'data/ticket';
    import { pullData } from 'api/tuanTicket';
    import getDefaultModel from '../common/defaultModel';

    export default {
        components: { ContentBlock },
        data() {
            return {
                pulling: false,
                pullId: '',
                relationMtDealId: ''
            }
        },
        props: {
            model: {
                type: Object,
                required: true
            },
            mode: {
                type: String,
                required: false
            },
            setModel: {
                type: Function
            },
            extra: {
                type: Object,
                required: true
            }
        },
        created() {
            if (parseInt(this.model.groupRule.relationMtDealId, 10) > 0) {
                this.relationMtDealId = this.model.groupRule.relationMtDealId;
            }
        },
        methods: {
            error: function (message) {
                this.$Message.error({
                    content: message,
                    duration: 5
                });
            },
            pull: async function() {
                this.$Modal.confirm({
                    onOk: async () => {
                        if (await this.setModel(this.pullId, this.extra.contractNum)) {
                            this.relationMtDealId = this.pullId;
                        }
                    },
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: this.pullId,
                                autofocus: true,
                                placeholder: '请输入拉取dealid'
                            },
                            on: {
                                input: (val) => {
                                    this.pullId = val;
                                }
                            }
                        })
                    }
                })
            }
        }
    }
</script>
<style rel="stylesheet/css" lang="postcss" scoped type="text/postcss">
    .inline-input {
        display: inline-block;
        margin: 0;
    }
    .nano-select {
        width: 62px;
    }
</style>


// WEBPACK FOOTER //
// Rule.vue?6bcb10d6